import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["rows", "name", "maxlength", "placeholder", "aria-label"]
const _hoisted_2 = ["name", "maxlength", "placeholder", "aria-label"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('input-container'))
  }, [
    _createElementVNode("form", {
      class: _normalizeClass(_ctx.getClass('form-inline')),
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_ctx.rows && _ctx.rows > 1)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 0,
            class: _normalizeClass(_ctx.getClass('modal-input ')),
            rows: _ctx.rows,
            cols: "50",
            name: _ctx.component.name ? _ctx.component.name : 'field_name',
            maxlength: _ctx.component.maxLength ? _ctx.component.maxLength : 1000,
            placeholder: _ctx.component.placeholder ? _ctx.component.placeholder : 'Enter text here',
            "aria-label": _ctx.component.placeholder ? _ctx.component.placeholder : 'Enter text here',
            spellcheck: "false",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.fieldValue) = $event))
          }, null, 10 /* CLASS, PROPS */, _hoisted_1)), [
            [
              _vModelText,
              _ctx.fieldValue,
              void 0,
              { trim: true }
            ]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            class: _normalizeClass(_ctx.getClass('modal-input ')),
            name: _ctx.component.name ? _ctx.component.name : 'field_name',
            maxlength: _ctx.component.maxLength ? _ctx.component.maxLength : 1000,
            placeholder: _ctx.component.placeholder ? _ctx.component.placeholder : 'Enter text here',
            "aria-label": _ctx.component.placeholder ? _ctx.component.placeholder : 'Enter text here',
            spellcheck: "false",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.fieldValue) = $event))
          }, null, 10 /* CLASS, PROPS */, _hoisted_2)), [
            [
              _vModelText,
              _ctx.fieldValue,
              void 0,
              { trim: true }
            ]
          ])
    ], 34 /* CLASS, NEED_HYDRATION */)
  ], 2 /* CLASS */))
}